export default __webpack_public_path__ + "media/images/paylogos/color/electron-92edaf0be04559dd409d4c5977ebb106.png";